import styled from 'styled-components';
import {
  tablet_portrait_breakpoint,
  desktop_breakpoint,
} from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';
import Colors from 'pubweb-smokey/dist/colors';

export const FindAHomeNoListingsStyles = styled.div`
  .no-listings-container {
    h3,
    p {
      text-align: center;
    }
  }
  .expand {
    font-family: 'source-sans-pro', sans-serif;
    color: ${Colors.primary.claytonBlue.standard};
    cursor: pointer;
  }
  .illustration-container {
    text-align: center;
    margin-top: 30px;
    margin-bottom: 10px;
    height: 100vh;
    max-height: 177px;
    position: relative;
  }
  .illustration {
    max-width: 100%;
  }

  @media only screen and (min-width: ${tablet_portrait_breakpoint}px) {
    .illustration-container {
      max-height: 334px;
    }
  }

  @media only screen and (min-width: ${desktop_breakpoint}px) {
    .illustration-container {
      margin-top: 50px;
      margin-bottom: 20px;
      max-height: 420px;
    }
  }
`;
